import type { IconData } from '@stacksjs/iconify-core'

export const justifyLeft: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 63.998h480v32H16zm0 88h480v32H16zm0 88h480v32H16zm0 88h480v32H16zm0 88h320v32H16z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default justifyLeft
